import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import SOSItem from "./SOSItem";

const SOSDetails = () => {
    const activeCase = useSelector(state => state.case.activeCase) 

    const [data, setData] = useState(null)

    useEffect(() => {
        if (activeCase) {      
            setData(activeCase.case_sos)            
        }
    }, [activeCase])

    return <>
        {data && <SOSItem sosData={data} apiCase={'case_sos'}/>}
    </>
}

export default SOSDetails